import React, { useCallback, useState } from "react";
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import toast from 'react-hot-toast';

import { MdMail, MdLock } from "react-icons/md";

import MiddleLayout from '../layouts/MiddleLayout'
import LoadableButton from '../components/LoadableButton'
import Logo from '../assets/logo.png'

const Login = () => {
  const [loading, setLoading] = useState(false)

  const handleSubmit = useCallback(async e => {
    e.preventDefault()
    setLoading(true)
    const { email, password } = e.target.elements
    const auth = getAuth()

    try {
      await signInWithEmailAndPassword(auth, email.value, password.value)
      toast.success('Connexion réussie ! Patientez...')
    } catch (e: any) {
      toast.error(e.message)
      setLoading(false)
    }
  }, [])

  return (
    <MiddleLayout>
      <div className="flex flex-col w-full max-w-md px-4 py-8 bg-white rounded-lg shadow sm:px-6 md:px-8 lg:px-10">
        <div className="self-center mb-6 text-xl font-light text-gray-600 sm:text-2xl">
          <div className="flex flex-col justify-center items-center">
            <img src={Logo} alt='logo app' className="w-24 "/>
            <span className="uppercase inline-block">Connexion</span>
          </div>
        </div>
        <div className="mt-8">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col mb-2">
              <div className="flex relative ">
                <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b border-gray-300 text-gray-500 shadow-sm text-sm">
                  <MdMail size={15} />
                </span>
                <input type="text" name="email" className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" placeholder="Email"/>
              </div>
            </div>
            <div className="flex flex-col mb-6">
              <div className="flex relative ">
                <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                  <MdLock size={15}/>
                </span>
                <input type="password" name="password" className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" placeholder="Mot de passe"/>
              </div>
            </div>
            <div className="flex items-center mb-6 -mt-4">
              <div className="flex ml-auto">
                {/*<Link disabled to="/" className="inline-flex text-xs font-thin text-gray-500 sm:text-sm dark:text-gray-100 hover:text-gray-700 dark:hover:text-white">
                  Mot de passe oublié ?
                </Link>*/}
              </div>
            </div>
              <div className="flex w-full">
                <LoadableButton title={loading ? 'Connexion...' : "Se connecter"} isSubmit loading={loading} />
              </div>
          </form>
        </div>
        <div className="flex items-center justify-center mt-6">
          <a 
            href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Scenup] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`}
            className="inline-flex items-center text-xs font-thin text-center text-gray-500 hover:text-gray-700">
            <span className="ml-2">
                Vous n'avez pas de compte ?
            </span>
          </a>
        </div>
      </div>
    </MiddleLayout>
  );
}

export default Login